import React, { useState, useEffect } from "react";

const TimerTab = ({updateCountdownTimerTabData,countdownTimerTabData}) => {
    const [activeTimeElementsTab, setActiveTimeElementsTab] = useState("main");
    const [selectedStartDate, setSelectedStartDate] = useState(countdownTimerTabData.timer_start_date);
    const [selectedEndDate, setSelectedEndDate] = useState(countdownTimerTabData.timer_end_date);
    const [positionType, setPositionType] = useState(countdownTimerTabData.timer_position_type);
    const [timerMessage, setTimerMessage] = useState(countdownTimerTabData.timer_message_before_timer);
    const [selectedDisplayLavels, setDisplayLavels] = useState(countdownTimerTabData.timer_counters_labels_displays_count || []);
    const [selectedDaysLavel, setDaysLavel] = useState(countdownTimerTabData.timer_days_label);
    const [selectedHoursLavel, setHoursLavel] = useState(countdownTimerTabData.timer_hours_label);
    const [selectedMinutesLavel, setMinutesLavel] = useState(countdownTimerTabData.timer_minutes_label);
    const [selectedSecondsLavel, setSecondsLavel] = useState(countdownTimerTabData.timer_seconds_label);

    // Handler Start Date Change
    const handleStartDateChange = (event) => {
        const value = event.target.value;
        setSelectedStartDate(value);
        updateCountdownTimerTabData("timer_start_date", value);
    };

    // Handler End Date Change
    const handleEndDateChange = (event) => {
        const value = event.target.value;
        setSelectedEndDate(value);
        updateCountdownTimerTabData("timer_end_date", value);
    };

    //Time Schedule Start Time
    const [selectedSTartTimeTimeSchedule, setSelectedSTartTimeTimeSchedule] = useState(countdownTimerTabData.timer_start_time);
    const [showSTartTimeTimeScheduleDropdown, setShowSTartTimeTimeScheduleDropdown] = useState(false);
    const layoutSTartTimeTimeScheduleValues = ['12:00 AM', '1:00 AM','2:00 AM','3:00 AM','4:00 AM','5:00 AM','6:00 AM','7:00 AM','8:00 AM','9:00 AM','10:00 AM','11:00 AM'];
    const toggleSTartTimeTimeScheduleDropdown = () => {
        setShowSTartTimeTimeScheduleDropdown(!showSTartTimeTimeScheduleDropdown);
    };
    const handleSTartTimeTimeScheduleSelect = (spacing) => {
        setSelectedSTartTimeTimeSchedule(spacing);
        setShowSTartTimeTimeScheduleDropdown(false);
        updateCountdownTimerTabData("timer_start_time", spacing);
    };

    //Time Schedule End Time
    const [selectedEndTimeTimeSchedule, setSelectedEndTimeTimeSchedule] = useState(countdownTimerTabData.timer_end_time);
    const [showEndTimeTimeScheduleDropdown, setShowEndTimeTimeScheduleDropdown] = useState(false);
    const layoutEndTimeTimeScheduleValues = ['12:00 AM', '1:00 AM','2:00 AM','3:00 AM','4:00 AM','5:00 AM','6:00 AM','7:00 AM','8:00 AM','9:00 AM','10:00 AM','11:00 AM'];
    const toggleEndTimeTimeScheduleDropdown = () => {
        setShowEndTimeTimeScheduleDropdown(!showEndTimeTimeScheduleDropdown);
    };
    const handleEndTimeTimeScheduleSelect = (spacing) => {
        setSelectedEndTimeTimeSchedule(spacing);
        setShowEndTimeTimeScheduleDropdown(false);
        updateCountdownTimerTabData("timer_end_time", spacing);
    };
    
    useEffect(() => {
        if (countdownTimerTabData.timer_position_type) {
            setPositionType(countdownTimerTabData.timer_position_type);
        }
    }, [countdownTimerTabData.timer_position_type]);
    
    // Handler Position Type Change
    const handlePositionTypeChange = (event) => {
        const value = event.target.value;
        setPositionType(value);
        updateCountdownTimerTabData("timer_position_type", value);
    };

    // Handlers Message Before Timer Change
    const handleTimerMessageChange = (e) => {
        const value = e.target.value;
        setTimerMessage(value);
        updateCountdownTimerTabData("timer_message_before_timer", value); 
    };

    // UseEffect Display Lavels Change
    useEffect(() => {
        // Sync state if countdownTimerTabData updates from outside
        if (Array.isArray(countdownTimerTabData.timer_counters_labels_displays_count)) {
            setDisplayLavels(countdownTimerTabData.timer_counters_labels_displays_count);
        } else if (typeof countdownTimerTabData.timer_counters_labels_displays_count === 'string') {
            try {
            const days_parsed = JSON.parse(countdownTimerTabData.timer_counters_labels_displays_count);
            setDisplayLavels(days_parsed);
            } catch (e) {
            // Fallback if not a valid JSON string
            const daysFromString = countdownTimerTabData.timer_counters_labels_displays_count.split(',').map(item => item.trim());
            setDisplayLavels(daysFromString);
            }
        }
    }, [countdownTimerTabData.timer_counters_labels_displays_count]); 

    // Handlers Display Lavels Change
    const handleDisplayLavelsChange = (event) => {
        const { value, checked } = event.target;
        let updatedDisplayLavels = [...selectedDisplayLavels];
    
        if (checked) {
            if (!updatedDisplayLavels.includes(value)) {
                updatedDisplayLavels.push(value);
            }
        } else {
            updatedDisplayLavels = updatedDisplayLavels.filter(device => device !== value);
        }
    
        setDisplayLavels(updatedDisplayLavels);
        updateCountdownTimerTabData("timer_counters_labels_displays_count", JSON.stringify(updatedDisplayLavels));
    };

    // Handlers Days Lavel Change
    const handleDaysLavelChange = (e) => {
        const value = e.target.value;
        setDaysLavel(value);
        updateCountdownTimerTabData("timer_days_label", value); 
    };

    // Handlers Hours Lavel Change
    const handleHoursLavelChange = (e) => {
        const value = e.target.value;
        setHoursLavel(value);
        updateCountdownTimerTabData("timer_hours_label", value); 
    };

    // Handlers Minutes Lavel Change
    const handleMinutesLavelChange = (e) => {
        const value = e.target.value;
        setMinutesLavel(value);
        updateCountdownTimerTabData("timer_minutes_label", value); 
    };

    // Handlers Seconds Lavel Change
    const handleSecondsLavelChange = (e) => {
        const value = e.target.value;
        setSecondsLavel(value);
        updateCountdownTimerTabData("timer_seconds_label", value); 
    };

    return (
        <div className="countdown-timer-side-baar-timer-tab">
            {activeTimeElementsTab === "main" && (
                <>
                    <span>Timer</span>
                    <div className="side-baar-box-header">
                        <div className="box-header-row last-border-none">
                            <span>Show Icon in Button</span>
                            <em>Start-To-Finish Timer</em>
                        </div>
                    </div>
                    <div className="side-baar-box-header">
                        <div className="box-header-row">
                            <span>Start Time</span>
                            <div className="date-time-box-timer-em">
                                <input
                                    type="date"
                                    value={selectedStartDate}
                                    onChange={handleStartDateChange}
                                    className="date-picker"
                                />
                                <i>at</i>
                                <em className="mt-0" onClick={toggleSTartTimeTimeScheduleDropdown}>{selectedSTartTimeTimeSchedule}</em>
                                {showSTartTimeTimeScheduleDropdown && (
                                    <ul className="dropdown-list">
                                        {layoutSTartTimeTimeScheduleValues.map((spacing) => (
                                            <li key={spacing} onClick={() => handleSTartTimeTimeScheduleSelect(spacing)}>
                                                {spacing}
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        </div>
                        <div className="box-header-row">
                            <span>End Time</span>
                            <div className="date-time-box-timer-em">
                                <input
                                    type="date"
                                    value={selectedEndDate}
                                    onChange={handleEndDateChange}
                                    className="date-picker"
                                />
                                <i>at</i>
                                <em className="mt-0" onClick={toggleEndTimeTimeScheduleDropdown}>{selectedEndTimeTimeSchedule}</em>
                                {showEndTimeTimeScheduleDropdown && (
                                    <ul className="dropdown-list">
                                        {layoutEndTimeTimeScheduleValues.map((spacing) => (
                                            <li key={spacing} onClick={() => handleEndTimeTimeScheduleSelect(spacing)}>
                                                {spacing}
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        </div>
                        {/*<div className="box-header-row last-border-none">
                            <span>Time Zone</span>
                            <em>(GMT+05:30) Asia/Kolkata</em>
                        </div>*/}
                    </div>
                    <div className="side-baar-box-header">
                        <div className="box-header-row">
                            <h6 className="h6-tage">Position</h6>
                            <ul className="pages-list-two">
                                <li>
                                    <div className="form-group">
                                        <input id="timer_position_type1" type="radio" name="timer_position_type" value="install_to_required_position" onChange={handlePositionTypeChange} checked={positionType === 'install_to_required_position'} />
                                        <label for="timer_position_type1">Install To Required Position</label>
                                    </div>
                                </li>
                                <li>
                                    <div className="form-group">
                                        <input id="timer_position_type2" type="radio" name="timer_position_type" value="static_top_banner" onChange={handlePositionTypeChange} checked={positionType === 'static_top_banner'} />
                                        <label for="timer_position_type2">Static Top Banner</label>
                                    </div>
                                </li>
                                <li>
                                    <div className="form-group">
                                        <input id="timer_position_type3" type="radio" name="timer_position_type" value="floating_top_banner" onChange={handlePositionTypeChange} checked={positionType === 'floating_top_banner'} />
                                        <label for="timer_position_type3">Floating Top Banner</label>
                                    </div>
                                </li>
                                <li>
                                    <div className="form-group">
                                        <input id="timer_position_type4" type="radio" name="timer_position_type" value="floating_bottom_banner" onChange={handlePositionTypeChange} checked={positionType === 'floating_bottom_banner'} />
                                        <label for="timer_position_type4">Floating Bottom Banner</label>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="side-baar-box-header">
                        <div className="box-header-row">
                            <h6 className="h6-tage">Message Before Timer</h6>
                            <textarea className="timer-message" onChange={handleTimerMessageChange} placeholder="Type Here.." value={timerMessage}></textarea>
                        </div>
                    </div>
                    <div className="customize-elements-list">
                        <ul>
                            <li>
                                <button onClick={() => setActiveTimeElementsTab("counters_labels")}>Counters & Labels <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                            <li>
                                <button onClick={() => setActiveTimeElementsTab("action_after_timer")}>Action After Timer Finishes <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                        </ul>
                    </div>
                </>
            )}

            {activeTimeElementsTab === "counters_labels" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveTimeElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button>Counters & Labels</span>
                        <div className="side-baar-box-header">
                            <div className="box-header-row">
                                <p>Display The Count In</p>
                                <ul>
                                    <li>
                                        <div className="form-group">
                                            <input id="display_days" type="checkbox" value="Days" checked={selectedDisplayLavels.includes("Days")} onChange={handleDisplayLavelsChange} />
                                            <label for="display_days">Days</label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="form-group">
                                            <input id="display_hours" type="checkbox" value="Hours" checked={selectedDisplayLavels.includes("Hours")} onChange={handleDisplayLavelsChange} />
                                            <label for="display_hours">Hours</label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="form-group">
                                            <input id="display_minutes" type="checkbox" value="Minutes" checked={selectedDisplayLavels.includes("Minutes")} onChange={handleDisplayLavelsChange} />
                                            <label for="display_minutes">Minutes</label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="form-group">
                                            <input id="display_seconds" type="checkbox" value="Seconds" checked={selectedDisplayLavels.includes("Seconds")} onChange={handleDisplayLavelsChange} />
                                            <label for="display_seconds">Seconds</label>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <div className="box-header-row">
                                <h6 className="h6-tage">Days Label</h6>
                                <input className="timer-input-link" type="text" value={selectedDaysLavel} onChange={handleDaysLavelChange}/>
                            </div>
                            <div className="box-header-row">
                                <h6 className="h6-tage">Hours Label</h6>
                                <input className="timer-input-link" type="text" value={selectedHoursLavel} onChange={handleHoursLavelChange} />
                            </div>
                            <div className="box-header-row">
                                <h6 className="h6-tage">Minutes Label</h6>
                                <input className="timer-input-link" type="text" value={selectedMinutesLavel} onChange={handleMinutesLavelChange} />
                            </div>
                            <div className="box-header-row">
                                <h6 className="h6-tage">Seconds Label</h6>
                                <input className="timer-input-link" type="text" value={selectedSecondsLavel} onChange={handleSecondsLavelChange} />
                            </div>
                        </div>

                    </div>
                </>
            )}

            {activeTimeElementsTab === "action_after_timer" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveTimeElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button>Action After Timer Finishes</span>
                        <div className="side-baar-box-header">
                            <div className="box-header-row">
                               <span>Select Action</span>
                               <em>Hide Timer</em>
                            </div>
                        </div>

                    </div>
                </>
            )}
        </div>
    );
};

export default TimerTab;